import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutgaurdGuard } from './gaurd/layoutgaurd.guard';
import { LoginComponent } from './login/login.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { ResetpageComponent } from './resetpage/resetpage.component';
import { PagenotaccessrightComponent } from './pagenotaccessright/pagenotaccessright.component';



const routes :Routes= [
  {path:'',
  canActivate:[LayoutgaurdGuard],
  loadChildren:()=>import('../app/views/main-layout/main-layout.module').then((m)=>m.MainLayoutModule)
},
  {path:'not-authorised',component:PagenotaccessrightComponent},

  {path: 'login',component: LoginComponent},
   {path: 'resetpassword',component: ResetpageComponent},
  {path:'**', component:PagenotfoundComponent},  
];
@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
